module.exports = __webpack_public_path__ + "img/Group 427320768@2x.eb7b09dd.png";